import React from 'react';
import TipoAtendimentoApi from '../api/TipoAtendimentoApi';
import BancoApi from '../api/BancoApi';
import BeneficiarioApi from '../api/BeneficiarioApi';
import DemonstrativoApi from '../api/DemonstrativoApi';
import FaturaApi from '../api/FaturaApi';
import GlosaApi from '../api/GlosaApi';
import OrgaoExternoApi from '../api/OrgaoExternoApi';
import PrestadorApi from '../api/PrestadorApi';
import ProfissionalApi from '../api/ProfissionalApi';
import TipoSituacaoServidorApi from '../api/TipoSituacaoServidorApi';
import UfApi from '../api/UfApi';
import AcertoMensalidadeApi from '../api/AcertoMensalidadeApi';
import AcertoCoparticipacaoApi from '../api/AcertoCoparticipacaoApi';
import DividaServDesligadoApi from '../api/DividaServDesligadoApi';
import AcertosDiversosApi from '../api/AcertosDiversosApi';
import ItemTabelaApi from '../api/ItemTabelaApi';
import { getRoles } from '../util/keycloak';
import AuxilioSaudeApi from '../api/AuxilioSaudeApi';
import TaxaApi from '../api/TaxaApi';

const AplicacaoContext = React.createContext({});

class AplicacaoProvider extends React.Component {
  beneficiarioApi = new BeneficiarioApi();
  tipoAtendimentoApi = new TipoAtendimentoApi();
  tiposDeSituacaoApi = new TipoSituacaoServidorApi();
  glosaApi = new GlosaApi();
  prestadorApi = new PrestadorApi();
  faturaApi = new FaturaApi();
  orgaoExternoApi = new OrgaoExternoApi();
  bancoApi = new BancoApi();
  demonstrativoApi = new DemonstrativoApi();
  profissionalApi = new ProfissionalApi();
  ufApi = new UfApi();
  acertoMensalidadeApi = new AcertoMensalidadeApi();
  acertoCoparticipacaoApi = new AcertoCoparticipacaoApi();
  auxilioSaudeApi = new AuxilioSaudeApi();
  acertosDiversosApi = new AcertosDiversosApi();
  dividaServDesligadoApi = new DividaServDesligadoApi();
  itemTabelaApi = new ItemTabelaApi();
  taxaApi = new TaxaApi();

  state = {
    beneficiarios: [],
    beneficiariosMaisPensionistas: [],
    tiposDeAtendimento: [],
    tiposDeSituacao: [],
    motivosDeGlosa: [],
    prestadores: [],
    prestadoresCredenciados: [],
    prestadoresSemOrgaoExterno: [],
    faturas: [],
    lotes: [],
    lotesRecurso: [],
    orgaosExternos: [],
    bancos: [],
    demonstrativos: [],
    profissionais: [],
    especialidades: [],
    CROs: [],
    UFs: [],
    grupos: [],
    protocolosAcerto: [],
    origensAcerto: [],
    estadosAcerto: [],
    estadosAuxilio: [],
    protocolosAcertoCopart: [],
    tiposAcertoCopart: [],
    estadosAcertoCopart: [],
    protocolosAcertosDiversos: [],
    eventosDividaServDesligado: [],
    tiposDividaServDesligado: [],
    servidoresDesligados: [],
    itemTabelaTipos: [],
    itemTabelaTabelas: [],
    nomesServidoresSemVinculo: [],
    tiposTaxa: []
  }

  getBeneficiarios = async () => {
    if (this.state.beneficiarios === undefined || this.state.beneficiarios.length === 0) {
      const beneficiarios = await this.beneficiarioApi.consultarNomes();
      this.setState({ beneficiarios: beneficiarios || []});
      return beneficiarios;
    }

    return this.state.beneficiarios;
  }  
  getBeneficiariosMaisPensionistas = async () => {
    if (this.state.beneficiariosMaisPensionistas === undefined || this.state.beneficiariosMaisPensionistas.length === 0) {
      const beneficiariosMaisPensionistas = await this.beneficiarioApi.consultarNomesMaisPensionista();
      this.setState({ beneficiariosMaisPensionistas: beneficiariosMaisPensionistas || []});
      return beneficiariosMaisPensionistas;
    }

    return this.state.beneficiariosMaisPensionistas;
  }  
  getNomesServidoresSemVinculo = async () => {
    if (this.state.nomesServidoresSemVinculo === undefined || this.state.nomesServidoresSemVinculo.length === 0) {
      const nomesServidoresSemVinculo = await this.beneficiarioApi.consultarNomesServidoresSemVinculo();
      this.setState({ nomesServidoresSemVinculo: nomesServidoresSemVinculo || []});
      return nomesServidoresSemVinculo;
    }
    return this.state.nomesServidoresSemVinculo;
  }
  getTiposDeAtendimento = async () => {
    if (this.state.tiposDeAtendimento === undefined || this.state.tiposDeAtendimento.length === 0) {
      const tiposDeAtendimento = await this.tipoAtendimentoApi.consultarTiposAtendimento();
      this.setState({ tiposDeAtendimento: tiposDeAtendimento || [] });
      return tiposDeAtendimento;
    }

    return this.state.tiposDeAtendimento;
  }
  getTiposDeSituacao = async () => {
    if (this.state.tiposDeSituacao === undefined || this.state.tiposDeSituacao.length === 0) {
      const tiposDeSituacao = await this.tiposDeSituacaoApi.consultarTiposSituacao();
      this.setState({ tiposDeSituacao: tiposDeSituacao || [] });
      return tiposDeSituacao;
    }
    return this.state.tiposDeSituacao;
  }
  getMotivosDeGlosa = async () => {
    if (this.state.motivosDeGlosa === undefined || this.state.motivosDeGlosa.length === 0) {
      const motivosDeGlosa = await this.glosaApi.consultarMotivosDeGlosa();
      this.setState({ motivosDeGlosa: motivosDeGlosa || [] });
      return motivosDeGlosa;
    }
    return this.state.motivosDeGlosa;
  }

  getPrestadores = async () => {
    if (this.state.prestadores === undefined || this.state.prestadores.length === 0) {
      const prestadores = await this.prestadorApi.consultarNomesTodosPrestadores();
      this.setState({ prestadores: prestadores || [] });
      return prestadores;
    }
    return this.state.prestadores;
  }

  getPrestadoresCredenciados = async () => {
    if (this.state.prestadoresCredenciados === undefined || this.state.prestadoresCredenciados.length === 0) {
      const prestadoresCredenciados = await this.prestadorApi.consultarNomesTodosPrestadoresCredenciados();
      this.setState({ prestadoresCredenciados: prestadoresCredenciados || [] });
      return prestadoresCredenciados;
    }
    return this.state.prestadoresCredenciados;
  }

  getLotes = async () => {
      const lotes = await this.faturaApi.consultarCodigoENumeroLotes();
      this.setState({ lotes: lotes || [] });
      return lotes;
  }
  getLotesRecurso = async () => {
    const lotesRecurso = await this.faturaApi.consultarCodigoENumeroLotesRecurso();
    this.setState({ lotesRecurso: lotesRecurso || [] });
    return lotesRecurso;
}
  getFaturas = async () => {
    const faturas = await this.faturaApi.consultarCodigoENumeroFaturas();
    this.setState({ faturas: faturas || [] });
    return faturas;
}

  getOrgaosExternos = async () => {
    if (this.state.orgaosExternos === undefined || this.state.orgaosExternos.length === 0) {
      const orgaosExternos = await this.orgaoExternoApi.consultarOrgaosExternos();
      this.setState({ orgaosExternos: orgaosExternos || [] });
      return orgaosExternos;
    }
    return this.state.orgaosExternos;
  }

  getBancos = async () => {
    if (this.state.bancos === undefined || this.state.bancos.length === 0) {
      const bancos = await this.bancoApi.consultarBancos();
      this.setState({ bancos: bancos || [] });
      return bancos;
    }
    return this.state.bancos;
  }

  getDemonstrativos = async () => {
    if (this.state.demonstrativos === undefined || this.state.demonstrativos.length === 0) {
      const demonstrativos = await this.demonstrativoApi.consultarDemonstrativos();
      this.setState({ demonstrativos: demonstrativos || [] });
      return demonstrativos;
    }
    return this.state.demonstrativos;
  }

  getUfs = async () => {
    if (this.state.UFs === undefined || this.state.UFs.length === 0) {
      const UFs = await this.ufApi.consultarUFs();
      this.setState({ UFs: UFs || [] });
      return UFs;
    }
    return this.state.UFs;
  }
  getProfissionais = async () => {
    if (this.state.profissionais === undefined || this.state.profissionais.length === 0) {
      const profissionais = await this.profissionalApi.consultarNomesTodosProfissionais();
      this.setState({ profissionais: profissionais || [] });
      return profissionais;
    }
    return this.state.profissionais;
  }

  getEspecialidades = async () => {
    if (this.state.especialidades === undefined || this.state.especialidades.length === 0) {
      const especialidades = await this.profissionalApi.consultarEspecialidades();
      this.setState({ especialidades: especialidades || [] });
      return especialidades;
    }
    return this.state.especialidades;
  }

  getCROs = async () => {
    if (this.state.CROs === undefined || this.state.CROs.length === 0) {
      const CROs = await this.profissionalApi.consultarCROs();
      this.setState({ CROs: CROs || [] });
      return CROs;
    }
    return this.state.CROs;
  }

  getPrestadorSemOrgaoExterno = async () => {
    if (this.state.prestadoresSemOrgaoExterno === undefined || this.state.prestadoresSemOrgaoExterno.length === 0) {
      const prestadoresSemOrgaoExterno = await this.prestadorApi.consultarPrestadoresSemOrgaoExterno();
      this.setState({ prestadoresSemOrgaoExterno: prestadoresSemOrgaoExterno || [] });
      return prestadoresSemOrgaoExterno;
    }
    return this.state.prestadoresSemOrgaoExterno;
  }

  getGrupos = async () => {
    if (this.state.grupos === undefined || this.state.grupos.length === 0) {
      const grupos = await this.prestadorApi.consultarNomesTodosGrupos();
      this.setState({ grupos: grupos || [] });
      return grupos;
    }
    return this.state.grupos;
  }
  getProtocolosAcerto = async () => {
    if (this.protocolosAcerto === undefined || this.protocolosAcerto.length === 0) {
      const protocolosAcerto = await this.acertoMensalidadeApi.consultarTodosOsProtocolos();
      this.setState({ protocolosAcerto: protocolosAcerto || [] });
      return protocolosAcerto;
    }
    return this.protocolosAcerto;
  }
  getOrigensAcerto = async () => {
    if (this.origensAcerto === undefined || this.origensAcerto.length === 0) {
      const origensAcerto = await this.acertoMensalidadeApi.consultarOrigens();
      this.setState({ origensAcerto: origensAcerto || [] });
      return origensAcerto;
    }
    return this.origensAcerto;
  }
  getEstadosAcerto = async () => {
    if (this.estadosAcerto === undefined || this.estadosAcerto.length === 0) {
      const estadosAcerto = await this.acertoMensalidadeApi.consultarEstados();
      this.setState({ estadosAcerto: estadosAcerto || [] });
      return estadosAcerto;
    }
    return this.estadosAcerto;
  }
  getEstadosAuxilio = async () => {
    if (this.estadosAuxilio === undefined || this.estadosAuxilio.length === 0) {
      const estadosAuxilio = await this.auxilioSaudeApi.consultarEstados();
      this.setState({ estadosAuxilio: estadosAuxilio || [] });
      return estadosAuxilio;
    }
    return this.estadosAuxilio;
  }
  getProtocolosAcertoCopart = async () => {
    if (this.state.protocolosAcertoCopart === undefined || this.state.protocolosAcertoCopart.length === 0) {
      const protocolosAcertoCopart = await this.acertoCoparticipacaoApi.consultarTodosOsProtocolos();
      this.setState({ protocolosAcertoCopart: protocolosAcertoCopart || [] });
      return protocolosAcertoCopart;
    }
    return this.state.protocolosAcertoCopart;
  }
  getTiposAcertoCopart = async () => {
    if (this.state.tiposAcertoCopart === undefined || this.state.tiposAcertoCopart.length === 0) {
      const tiposAcertoCopart = await this.acertoCoparticipacaoApi.consultarTipos();
      this.setState({ tiposAcertoCopart: tiposAcertoCopart || [] });
      return tiposAcertoCopart;
    }
    return this.state.tiposAcertoCopart;
  }
  getEstadosAcertoCopart = async () => {
    if (this.state.estadosAcertoCopart === undefined || this.state.estadosAcertoCopart.length === 0) {
      const estadosAcertoCopart = await this.acertoCoparticipacaoApi.consultarEstados();
      this.setState({ estadosAcertoCopart: estadosAcertoCopart || [] });
      return estadosAcertoCopart;
    }
    return this.state.estadosAcertoCopart;
  }
  getProtocolosAcertosDiversos = async () => {
    if (this.state.protocolosAcertosDiversos === undefined || this.state.protocolosAcertosDiversos.length === 0) {
      const protocolosAcertosDiversos = await this.acertosDiversosApi.consultarTodosOsProtocolos();
      this.setState({ protocolosAcertosDiversos: protocolosAcertosDiversos || [] });
      return protocolosAcertosDiversos;
    }
    return this.state.protocolosAcertosDiversos;
  }
  getEventosDividas = async () => {
    if (this.state.eventosDividaServDesligado === undefined || this.state.eventosDividaServDesligado.length === 0) {
      const eventosDividaServDesligado = await this.dividaServDesligadoApi.consultarEventos();
      this.setState({ eventosDividaServDesligado: eventosDividaServDesligado || [] });
      return eventosDividaServDesligado;
    }
    return this.state.eventosDividaServDesligado;
  }
  getTiposDividas = async () => {
    if (this.state.tiposDividaServDesligado === undefined || this.state.tiposDividaServDesligado.length === 0) {
      const tiposDividaServDesligado = await this.dividaServDesligadoApi.consultarTipos();
      this.setState({ tiposDividaServDesligado: tiposDividaServDesligado || [] });
      return tiposDividaServDesligado;
    }
    return this.state.tiposDividaServDesligado;
  }

  getServidoresDesligados = async () => {
    if (this.state.servidoresDesligados === undefined || this.state.servidoresDesligados.length === 0) {
      const servidoresDesligados = await this.dividaServDesligadoApi.consultarServidoresDesligados();
      this.setState({ servidoresDesligados: servidoresDesligados || [] });
      return servidoresDesligados;
    }
    return this.state.servidoresDesligados;
  }

  getItemTabelaTabelas = async () => {
    if (this.state.itemTabelaTabelas === undefined || this.state.itemTabelaTabelas.length === 0) {
      let itemTabelaTabelas = await this.itemTabelaApi.consultarTabelas();
      this.setState({ itemTabelaTabelas: itemTabelaTabelas || [] });
      return itemTabelaTabelas;
    }
    return this.state.itemTabelaTabelas;
  }

  getItemTabelaTipos = async () => {
    if (this.state.itemTabelaTipos === undefined || this.state.itemTabelaTipos.length === 0) {
      let itemTabelaTipos = await this.itemTabelaApi.consultarTiposDeItem();
      this.setState({ itemTabelaTipos: itemTabelaTipos || [] });
      return itemTabelaTipos;
    }
    return this.state.itemTabelaTipos;
  }
  getTiposTaxa = async () => {
    if (this.state.tiposTaxa === undefined || this.state.tiposTaxa.length === 0) {
      let tiposTaxa = await this.taxaApi.consultarTiposDeTaxa();
      this.setState({ tiposTaxa: tiposTaxa || [] });
      return tiposTaxa;
    }
    return this.state.tiposTaxa;
  }

  render () {
    return (
      <AplicacaoContext.Provider
        value={{
          beneficiarios: this.state.beneficiarios,
          tiposDeAtendimento: this.state.tiposDeAtendimento,
          tiposDeSituacao: this.state.tiposDeSituacao,
          motivosDeGlosa: this.state.motivosDeGlosa,
          prestadores: this.state.prestadores,
          prestadoresCredenciados: this.state.prestadoresCredenciados,
          prestadoresSemOrgaoExterno: this.state.prestadoresSemOrgaoExterno,
          faturas: this.state.faturas,
          orgaosExternos: this.state.orgaosExternos,
          bancos: this.state.bancos,
          demonstrativos: this.state.demonstrativos,
          profissionais: this.state.profissionais,
          especialidades: this.state.especialidades,
          CROs: this.state.CROs,
          UFs: this.state.UFs,
          grupos: this.state.grupos,
          protocolosAcerto: this.state.protocolosAcerto,
          origensAcerto: this.state.origensAcerto,
          estadosAcerto: this.state.estadosAcerto,
          protocolosAcertoCopart: this.state.protocolosAcertoCopart,
          tiposAcertoCopart: this.state.tiposAcertoCopart,
          estadosAcertoCopart: this.state.estadosAcertoCopart,
          protocolosAcertosDiversos: this.state.protocolosAcertosDiversos,
          eventosDividaServDesligado: this.state.eventosDividaServDesligado,
          tiposDividaServDesligado: this.state.tiposDividaServDesligado,
          servidoresDesligados: this.state.servidoresDesligados,
          itemTabelaTipos: this.state.itemTabelaTipos,
          itemTabelaTabelas: this.state.itemTabelaTabelas,
          getBeneficiarios: this.getBeneficiarios,
          getBeneficiariosMaisPensionistas: this.getBeneficiariosMaisPensionistas,
          getNomesServidoresSemVinculo: this.getNomesServidoresSemVinculo,
          getTiposDeAtendimento: this.getTiposDeAtendimento,
          getTiposDeSituacao: this.getTiposDeSituacao,
          getMotivosDeGlosa: this.getMotivosDeGlosa,
          getPrestadores: this.getPrestadores,
          getPrestadoresCredenciados: this.getPrestadoresCredenciados,
          getFaturas: this.getFaturas,
          getLotes: this.getLotes,
          getLotesRecurso: this.getLotesRecurso,
          getPrestadorSemOrgaoExterno: this.getPrestadorSemOrgaoExterno,
          getOrgaosExternos: this.getOrgaosExternos,
          getBancos: this.getBancos,
          getDemonstrativos: this.getDemonstrativos,
          getUfs: this.getUfs,
          getProfissionais: this.getProfissionais,
          getEspecialidades: this.getEspecialidades,
          getCROs: this.getCROs,
          getGrupos: this.getGrupos,
          getProtocolosAcerto: this.getProtocolosAcerto,
          getOrigensAcerto: this.getOrigensAcerto,
          getEstadosAcerto: this.getEstadosAcerto,
          getEstadosAuxilio: this.getEstadosAuxilio,
          getProtocolosAcertoCopart: this.getProtocolosAcertoCopart,
          getTiposAcertoCopart: this.getTiposAcertoCopart,
          getEstadosAcertoCopart: this.getEstadosAcertoCopart,
          getProtocolosAcertosDiversos: this.getProtocolosAcertosDiversos,
          getEventosDividas: this.getEventosDividas,
          getServidoresDesligados: this.getServidoresDesligados,
          getTiposDividas: this.getTiposDividas,
          getItemTabelaTabelas: this.getItemTabelaTabelas,
          getItemTabelaTipos: this.getItemTabelaTipos,
          getTiposTaxa: this.getTiposTaxa,
        }}
      >
        {this.props.children}
      </AplicacaoContext.Provider>
    );
  }
}

const AplicacaoConsumer = AplicacaoContext.Consumer;

function withAplicacao (Component) {
  return function ComponentWithAplicacaoContext (props) {
    return (
      <AplicacaoConsumer>
        {context => <Component {...context} {...props} />}
      </AplicacaoConsumer>
    );
  };
}
export default AplicacaoContext
export { AplicacaoProvider, withAplicacao };